<template>
  <div class="authcode-only">
    <el-row :gutter="12" align="middle" style="margin-bottom:16px;">
      <el-col :span="4">
        <el-input
          v-model="mac"
          placeholder="请输入MAC地址"
          clearable
        />
      </el-col>
      <el-col :span="4">
        <el-select v-model="cloud" placeholder="请选择云环境" clearable>
          <el-option
            v-for="c in platforms"
            :key="c"
            :label="c"
            :value="c"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="queryAuthCode">设备离线authcode查询</el-button>
      </el-col>
    </el-row>

     <!-- 1. 加载中 -->
    <el-card v-if="loading" class="text-center">
      查询中...
    </el-card>

    <!-- 2. 查询完毕但未找到任何 code -->
    <el-card
      v-else-if="!loading && hasAuthData && !hasAnyCode"
      class="text-center result-card"
    >
      <p class="text-success">非 authcode 问题</p>
    </el-card>

    <!-- 3. 查询完毕且有 code -->
    <el-card
      v-else-if="!loading && hasAuthData && hasAnyCode"
      class="result-card"
    >
      <p class="text-error">是 authcode 问题</p>
      <p>
        <strong>设备上报的 authcode：</strong>
        {{ authData.DevReportAuthCode }}
      </p>
      <p>
        <strong>云上的 authcode：</strong>
        {{ authData.MacPoolAuthCode }}
      </p>
    </el-card>
    <!-- 4. 未查询过时（loading=false 且 authData=null），什么都不显示 -->
  </div>
</template>

<script>
export default {
  name: 'AuthcodeOnly',
  data() {
    return {
      mac: '',
      cloud: '',
      platforms: [],
      authData: null,
      loading: false,
    }
  },
  created() {
    this.fetchCloudEnvs()
  },
  computed: {
    // 是否已经执行过一次查询（不论成功与否），只要 authData 不再是 null 就算查询过
    hasAuthData() {
      return this.authData !== null
    },
    // 如果 authData 已有值，判断是否拿到了任意一个 code
    hasAnyCode() {
      if (!this.hasAuthData) return false
      return !!this.authData.DevReportAuthCode || !!this.authData.MacPoolAuthCode
    },
  },
  methods: {
    fetchCloudEnvs() {
      this.$http.get(
        "cloud/env/",
        {},
        data => {
          this.platforms = data.data.results.map(item => item.cloud);
        },
        err => {
          console.error("拉取云环境列表失败", err);
          this.$message.error("拉取云环境列表出错");
        }
      );
    },

    queryAuthCode() {
      if (!this.mac.match(/^[A-Fa-f0-9]{12}$/)) {
        return this.$message.error(
          "MAC 地址格式不对，请输入 12 位十六进制字符串"
        );
      }
      if (!this.cloud) {
        return this.$message.error("请选择云环境");
      }

      this.loading = true;
      this.authData = null;

      this.$http.get(
        "sre-api/authcode/",
        { cloud: this.cloud, mac: this.mac },
        data => {
          // data 就是后端整段 JSON
          if (data.status === "success") {
            this.authData = data.data || {};
          } else {
            this.$message.error(data.msg || "查询失败");
            this.authData = {} ;
            
          }
          this.loading = false;
        },
        err => {
          console.error("查询认证码出错", err);
          this.$message.error("请求出错，请稍后重试");
          this.authData = {} ;
          this.loading = false;
        }
      );
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  padding: 20px 0;
}
.result-card {
  margin-top: 16px;
  padding: 16px;
}
/* 红色警示 */
.text-error {
  color: #F56C6C; /* Element UI danger color */
  font-weight: bold;
  margin-bottom: 12px;
}

/* 绿色提示 */
.text-success {
  color: #67C23A; /* Element UI success color */
  font-weight: bold;
}
</style>
